<template>
    <div class="user-auth">
        <van-form @submit="onSubmit">
            <van-cell-group inset>
                <!-- <van-field
                    v-model="formData.realName"
                    name="realName"
                    label="真实姓名"
                    placeholder="请输入真实姓名"
                    required
                    :rules="[{ required: true, message: '请输入真实姓名' }]"
                />
                <van-field
                    v-model="formData.idCard"
                    name="idCard"
                    label="身份证号"
                    placeholder="请输入身份证号"
                    required
                    :rules="[{ required: true, message: '请输入身份证号' }, { validator: validateIdCard }]"
                /> -->
                <van-field
                required
                    v-model="formData.email"
                    name="email"
                    label="邮箱"
                    placeholder="请输入邮箱"
                />
                <van-field
                    required
                    v-model="formData.wechat"
                    name="wechat"
                    label="微信号"
                    placeholder="请输入微信号"
                />
                <van-field
                    v-model="formData.qq"
                    name="qq"
                    label="QQ号"
                    placeholder="请输入QQ号"
                />
                <van-field
                required
                    v-model="formData.payPassword"
                    type="password"
                    name="payPassword"
                    label="设置平台支付密码"
                    placeholder="请输入6位支付密码"
                    :rules="[{ required: true, message: '请输入支付密码' }, { validator: validatePayPassword }]"
                />
                <van-field
                required
                    v-model="formData.confirmPayPassword"
                    type="password"
                    name="confirmPayPassword"
                    label="确认平台支付密码"
                    placeholder="请再次输入支付密码"
                    :rules="[{ required: true, message: '请确认支付密码' }, { validator: validateConfirmPassword }]"
                />
            </van-cell-group>
            <div style="margin: 16px;">
                <van-button  block type="primary" native-type="submit">
                    提交认证
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { showToast } from 'vant'
import request from '@/utils/request'
import CryptoJS from 'crypto-js';
export default {
    name: 'UserAuth',
    data() {
        return {
            formData: {
                realName: '',
                idCard: '',
                email: '',
                wechat: '',
                qq: '',
                payPassword: '',
                confirmPayPassword: ''
            }
        }
    },
    methods: {
        // 验证身份证号
        validateIdCard(val) {
            const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            if (!reg.test(val)) {
                return '请输入正确的身份证号'
            }
            return true
        },
        // 验证支付密码
        validatePayPassword(val) {
            if (val.length !== 6) {
                return '支付密码必须为6位'
            }
            if (!/^\d{6}$/.test(val)) {
                return '支付密码只能包含数字'
            }
            return true
        },
        // 验证确认密码
        validateConfirmPassword(val) {
            if (val !== this.formData.payPassword) {
                return '两次输入的密码不一致'
            }
            return true
        },
        // 提交表单
        async onSubmit(values) {
            console.log('表单数据：', values)
            // 这里添加提交到后端的逻辑
            const res = await request.post('/front/profile/identity/verify', {
          realName: values.realName,
          idCard: values.idCard,
          email: values.email,
          weiChat: values.wechat,
          qqNum: values.qq,
          payPass: CryptoJS.SHA256( values.payPassword).toString()
        })
        if(res.code == 200){
            showToast('实名认证成功')
            this.$router.push('/profile')
        }else{
            showToast('实名认证失败')
        }
          
        }
    }
}
</script>

<style scoped>
.user-auth {
    padding: 16px;
    background-color: #f7f8fa;
    min-height: 100vh;
}
</style>